<template>
	<div class="viewer">
		<div class="confirm-bg" @click="$emit('result', false)" />
		<div class="confirm-inner">
			<div class="confirm-title">{{ text }}</div>
			<div class="confirm-buttons">
				<uiButton
					class="confirm-btn"
					color="grey"
					@click="$emit('result', false)"
				>
					Нет
				</uiButton>
				<uiButton class="confirm-btn" @click="$emit('result', true)">
					Да
				</uiButton>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ConfirmView',
	props: {
		text: String,
	},
	mounted() {
		window.addEventListener('keydown', this.onEscape)
	},
	destroyed() {
		window.removeEventListener('keydown', this.onEscape)
	},
	methods: {
		onEscape(e) {
			if (e.key !== 'Escape') return
			this.$emit('close')
		},
	},
}
</script>

<style lang="less" scoped>
@import '../assets/app.less';

.confirm-bg {
	width: 100%;
	height: 100%;
	position: absolute;
	left: 0;
	top: 0;
	cursor: pointer;
}

.confirm-inner {
	padding: 30px 40px;
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: column;
	background: #fff;
	border-radius: 20px;
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
}

.confirm-title {
	text-align: center;
	margin-bottom: 20px;
	font-size: 30px;
	font-weight: 600;
}

.confirm-buttons {
	display: flex;
}

.confirm-btn {
	width: 120px;
	flex-grow: 1;
	float: left;
	display: none;
	margin: 10px !important;
}
</style>
